<script lang="ts">
	import imageError from '$lib/assets/image-error.png';
	import { getWebImageUrl } from '$lib/image';

	export let src: string | undefined;
	export let alt: string | undefined = 'Web Image';

	let { src: origSrc, alt: origAlt, ...rest } = $$props;

	$: resolvedSrc = getWebImageUrl(src);

	function handleError() {
		resolvedSrc = imageError;
	}
</script>

<img
	on:click
	on:keypress
	{...rest}
	src={resolvedSrc}
	{alt}
	on:error={handleError}
/>
